<template>
  <div class="mx-auto max-w-3xl px-16 py-24">
    <RouteStepper />
  </div>
</template>

<script lang="ts">
import RouteStepper from '../../../components/route_stepper/RouteStepper.vue';

export default {
  name: 'OnboardingSeeker',
  components: { RouteStepper },
};
</script>

